import Vue from 'vue';
import Vuex from 'vuex';
import auth0 from 'auth0-js';
import router from '../router';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userIsAuthorized: false,
    auth0: new auth0.WebAuth({
      domain: process.env.VUE_APP_AUTH0_CONFIG_DOMAIN,
      clientID: process.env.VUE_APP_AUTH0_CONFIG_CLIENT_ID,
      redirectUri: process.env.VUE_APP_DOMAIN_URL + '/callback',
      responseType: process.env.VUE_APP_AUTH0_RESPONSE_TYPE,
      scope: process.env.VUE_APP_AUTH0_SCOPE
    }),
    user: {},
    modules: {
      drawer: null,
      color: 'danger',
      image: 'https://s3.amazonaws.com/files.vremec.com.mx/pictures/IMG-20191207-WA0022.jpg',
      sidebarBackgroundColor: 'rgba(27, 27, 27, 0.74)'
    }
  },
  mutations: {
    setUserAuthorization: (state, newState ) =>  {
      state.userIsAuthorized = newState;
    }
  },
  actions: {
    auth0Login: (context) => {
      context.state.auth0.authorize();
    },
    auth0HandleAuthentication (context) {
      context.state.auth0.parseHash((err, authResult) => {
        context.state.user = authResult.idTokenPayload;
        if (authResult && authResult.accessToken && authResult.idToken) {
          let expiresAt = JSON.stringify(
            authResult.expiresIn * 1000 + new Date().getTime()
          )
          // save the tokens locally
          localStorage.setItem('access_token', authResult.accessToken);
          localStorage.setItem('id_token', authResult.idToken);
          localStorage.setItem('expires_at', expiresAt);  
          
          router.replace('/clientes');
        } 
        else if (err) {
          alert('Login failed. Error VRM-1');
          router.replace('/login');
          console.error(err);
        }
      })
    },
    getUserSession () {
      return localStorage.getItem('id_token');
    },  
    //eslint-disable-next-line
    auth0Logout (context) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('expires_at');
      //Auth0 Logout
      window.location.href = process.env.VUE_APP_AUTH0_CONFIG_DOMAIN_URL + "v2/logout?returnTo=" + process.env.VUE_APP_DOMAIN_URL + "/login&client_id=" + process.env.VUE_APP_AUTH0_CONFIG_CLIENT_ID; 
    },  
  }
})
